<div style="height: 483px;"
    [ngClass]="{'d-flex justify-content-center align-items-center': (httpService.getLoading('clientProfileLoader')) || !client}">
    <div *ngIf="!(httpService.getLoading('clientProfileLoader'))">
        <div *ngIf="!client" class="text-center py-5">
            <i class="fe fe-user-x fs-1 text-muted"></i>
            <p class="text-muted mt-3">{{ msg }}</p>
        </div>

        <div class="card rounded-4 m-0" *ngIf="client">
            <div class="card-dropdown dropdown"
                *ngIf="publicService.hasAnyPermission(['EDIT_CLIENT', 'DELETE_CLIENT'])">
                <div class="btn-group">
                    <span data-bs-toggle="dropdown" aria-expanded="false">
                        <i class="fe fe-more-vertical black-menu fs-2"></i>
                    </span>
                    <ul class="dropdown-menu dropdown-menu-end" *ngIf="client?.id != 1">
                        <li *ngIf="publicService.hasAnyPermission(['EDIT_CLIENT'])">
                            <a class="dropdown-item" [routerLink]="['/users/edit-client/' + client.id]"
                                (click)="activeModal.close()">
                                <i class="fe fe-edit"></i>
                                <span>{{ 'Edit' | translate }}</span>
                            </a>
                        </li>
                        <li *ngIf="publicService.hasAnyPermission(['INVITE_CLIENT'])">
                            <a class="dropdown-item" (click)="invite()">
                                <i class="fe fe-send"></i>
                                <span>{{ 'Invite' | translate }}</span>
                            </a>
                        </li>
                        <li *ngIf="publicService.hasAnyPermission(['VIEW_CLIENT_REPORT'])">
                            <a class="dropdown-item" [routerLink]="['/clients/' + client.id + '/report']">
                                <i class="fe fe-bar-chart-2"></i>
                                <span>{{ 'ViewReport' | translate }}</span>
                            </a>
                        </li>
                        <li *ngIf="publicService.hasAnyPermission(['RESET_CLIENT_PASSWORD'])">
                            <a class="dropdown-item" (click)="resetPassword()">
                                <i class="fe fe-refresh-cw"></i>
                                <span>{{ 'ResetPassword' | translate }}</span>
                            </a>
                        </li>
                        <li *ngIf="publicService.hasAllPermissions(['DELETE_CLIENT'])">
                            <hr class="dropdown-divider">
                        </li>
                        <li *ngIf="publicService.hasAnyPermission(['DELETE_CLIENT'])">
                            <a class="dropdown-item delete-item" (click)="delete()">
                                <span>{{ 'Delete' | translate }}</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="card-body pt-5 pb-3">
                <div style="min-height: 169px;">
                    <span class="avatar avatar-xl card-avatar mt-2" role="button"
                        (click)="publicService.openImage(client.full_name, client?.image)">
                        <img class="avatar-img rounded-circle" [lazyLoad]="client?.image"
                            [defaultImage]="'assets/img/no-user.png'" [errorImage]="'assets/img/no-user.png'"
                            style="box-shadow: 0px 0px 10px #00000025;">
                    </span>
                    <h2 class="text-center card-title mt-4">
                        {{ client.full_name || '-' }}
                    </h2>
                </div>
                <div class="g-0 border-top border-bottom row">
                    <div class="py-4 text-center col-6">
                        <h6 class="text-uppercase text-muted">{{ 'Email' | translate }}</h6>
                        <h4 class="mb-0">{{ client?.company_email || client?.personal_email || '-' }}</h4>
                    </div>
                    <div class="py-4 text-center col-6 border-start">
                        <h6 class="text-uppercase text-muted">{{ 'Phone' | translate }}</h6>
                        <h4 class="mb-0" *ngIf="client?.phone_number">
                            {{ (client?.country_code || '') + ' ' + (client?.phone_number || '') }}
                        </h4>
                        <h4 class="mb-0" *ngIf="!client?.phone_number">-</h4>
                    </div>
                </div>
                <div class="list-group-flush list-group">
                    <div class="list-group-item">
                        <div class="row align-items-center">
                            <div class="col"><small>{{ 'Role' | translate }}</small></div>
                            <div class="col-auto">
                                <small class="text-muted">{{ client?.role || '-' }}</small>
                            </div>
                        </div>
                    </div>
                    <div class="list-group-item">
                        <div class="row align-items-center">
                            <div class="col"><small>{{ 'Country' | translate }}</small></div>
                            <div class="col-auto">
                                <small class="text-muted">{{ client?.country_name || '-' }}</small>
                            </div>
                        </div>
                    </div>
                    <div class="list-group-item">
                        <div class="row align-items-center">
                            <div class="col"><small>{{ 'WhatsAppNumber' | translate }}</small></div>
                            <div class="col-auto">
                                <small class="text-muted">{{ client?.whatsapp_number || '-' }}</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <span class="loader" *ngIf="(httpService.getLoading('clientProfileLoader'))"></span>
</div>